module.exports = __webpack_public_path__ + "clock.svg?6f78851554a07766405fede7c0351799";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clock.svg
// module id = 61
// module chunks = 0